import {cn} from "@/lib/utils";

const Shape = ({ className }) => {
  return (
    <div
      className={cn('absolute w-3/4 h-full min-h-96 -z-10 rotate-[-9.819deg] left-0 -translate-y-[var(--spotlight-pb)]', className)}
      style={{
        backgroundImage:
          'radial-gradient(50% 50% at 50% 50%, rgba(0, 244, 161, 0.25) 0%, rgba(0, 244, 161, 0.00) 100%)',
        borderRadius: '756px'
      }}
    />
  );
};

export default Shape;
